export const name = "ST_EXTENT";
export const summary = `Gets the bounding box for a group of \`GEOGRAPHY\` values.`;
export const reference = `
## ST_EXTENT

Gets the bounding box for a group of \`GEOGRAPHY\` values.

\`\`\`
ST_EXTENT(geography_expression)
\`\`\`

### Description

Returns a \`STRUCT\` that represents the bounding box for the set of input\`GEOGRAPHY\` values. The bounding box is the minimal rectangle that encloses the geography. The edges of the rectangle follow constant lines of longitude and latitude.

Caveats:

- Returns \`NULL\` if all the inputs are \`NULL\` or empty geographies.
- The bounding box might cross the antimeridian if this allows for a smaller rectangle. In this case, the bounding box has one of its longitudinal bounds outside of the [-180, 180] range, so that \`xmin\` is smaller than the eastmost value \`xmax\`.
- If the longitude span of the bounding box is larger than or equal to 180 degrees, the function returns the bounding box with the longitude range of [-180, 180].


### Return type

\`STRUCT<xmin FLOAT64, ymin FLOAT64, xmax FLOAT64, ymax FLOAT64>\`.

Bounding box parts:

- \`xmin\`: The westmost constant longitude line that bounds the rectangle.
- \`xmax\`: The eastmost constant longitude line that bounds the rectangle.
- \`ymin\`: The minimum constant latitude line that bounds the rectangle.
- \`ymax\`: The maximum constant latitude line that bounds the rectangle.


### Example



\`\`\`
WITH data AS (
  SELECT 1 id, ST_GEOGFROMTEXT('POLYGON((-125 48, -124 46, -117 46, -117 49, -125 48))') g
  UNION ALL
  SELECT 2 id, ST_GEOGFROMTEXT('POLYGON((172 53, -130 55, -141 70, 172 53))') g
  UNION ALL
  SELECT 3 id, ST_GEOGFROMTEXT('POINT EMPTY') g
)
SELECT ST_EXTENT(g) AS box
FROM data

/*----------------------------------------------*
 | box |
 +----------------------------------------------+
 | {xmin:172, ymin:46, xmax:243, ymax:70} |
 *----------------------------------------------*/
\`\`\`

\`ST_BOUNDINGBOX\` for the non-aggregate version of \`ST_EXTENT\`.


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
